import React from 'react';
import "../applications-css/Maps.css";

// https://cuneyt.aliustaoglu.biz/en/using-google-maps-in-react-without-custom-libraries/

// user flow:
  // type in a location to view map
  // can add more locations/stops (10 MAX)
    // locations show up in sidebar
    // can remove them from sidebar
  // view directions

class Maps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLat: 34.3917,
      currentLng: -118.5426,
      markerLocs: [],
      waypointNames: [],
      waypoints: []
    }
    this.enterLocation = this.enterLocation.bind(this);

  }

  randomCoords() {
    let randomLat = -90 + (Math.random() * (90 + 90));
    let randomLng = -180 + (Math.random() * (180 + 180));
    this.setState({
      currentLat: randomLat,
      currentLng: randomLng,
      markerLocs: [...this.state.markerLocs, { lat: randomLat, lng: randomLng }],
    })
  }

  enterCoords() {
    // get coords from refs + convert to float
    let newLat = parseFloat(this.refs.latitudeRef.value);
    let newLng = parseFloat(this.refs.longitudeRef.value);
    // constrain accordingly
    let newLatLng = new window.google.maps.LatLng(newLat, newLng)
    this.setState({
      currentLat: newLatLng.lat(),
      currentLng: newLatLng.lng(),
      markerLocs: [...this.state.markerLocs, newLatLng]
    })
  }

  enterLocation() {
    // take input and convert to latlng with geocode
    if(this.state.waypoints.length + 1 > 10) {
      console.log("no");
    }
    else {
      let geocoder = new window.google.maps.Geocoder();
      let address = this.refs.locationRef.value;
      let newWaypoint = null;
      geocoder.geocode({'address': address}, function(results, status) {
        if (status === 'OK') {
          newWaypoint = results[0].geometry.location;
        }
        else {
          console.log('Geocode was not successful for the following reason: ' + status);
        }
        if(newWaypoint !== null) {
          this.setState({
            currentLat: newWaypoint.lat(),
            currentLng: newWaypoint.lng(),
            waypointNames: [...this.state.waypointNames, address],
            waypoints: [...this.state.waypoints, newWaypoint]
          })
        }
        this.refs.locationRef.value = '';
      }.bind(this));
    }
    this.refs.directionsRef.innerHTML = ""
  }

  removeLocation(e, index) {
    let newWaypointNames = this.state.waypointNames;
    newWaypointNames.splice(index, 1);
    let newWaypoints = this.state.waypoints;
     newWaypoints.splice(index, 1);
    this.setState({
      waypointNames: newWaypointNames,
      waypoints: newWaypoints
    });
    console.log(this.state.waypoints)
    this.refs.directionsRef.innerHTML = ""
  }

  viewLocation(e, index) {
    this.setState({
      currentLat: this.state.waypoints[index].lat(),
      currentLng: this.state.waypoints[index].lng(),
    })
  }

  clearWaypoints() {
    let newWaypointNames = [];
    let newWaypoints = [];
    this.setState({
      waypointNames: newWaypointNames,
      waypoints: newWaypoints
    });
    console.log(this.state.waypoints)
    this.refs.directionsRef.innerHTML = ""
  }

  getDirections() {
    if(this.state.waypoints.length === 0) {
      // do nothing
      console.log(":|")
    }
    else if(this.state.waypoints.length === 1) {
      console.log("lol nice try")
    }
    else {
      this.refs.directionsRef.innerHTML = ""
      let reformattedWaypoints = [];
      for(let i = 0; i < this.state.waypoints.length; i++) {
        let currentWaypoint = this.state.waypoints[i]
        let newLocation = {location: {lat: currentWaypoint.lat(), lng:  currentWaypoint.lng()}}
        reformattedWaypoints.push(newLocation);
      }
      let origin = reformattedWaypoints.shift();
      let destination = reformattedWaypoints.pop();
      var directionsRenderer = new window.google.maps.DirectionsRenderer();
      directionsRenderer.setPanel(this.refs.directionsRef);


      let directionsService = new window.google.maps.DirectionsService();
      const route = {
          origin: origin,
          destination: destination,
          waypoints: reformattedWaypoints,
          travelMode: 'DRIVING'
      }

      directionsService.route(route, function(response, status) {
        if(status === 'OK') {
          directionsRenderer.setDirections(response);
        }
      });
    }
  }

// <span style={{height: "100%", width: "100%"}}>Latitude: {this.state.currentLat} / Longitude: {this.state.currentLng}</span>
  render() {
    return(
      <div id="mapsWrapper" className="outsideWrapper">
        <div id="mapsHeader">
          <input type="text" id="urlInputField" ref="locationRef" spellCheck="false" rows="1">
          </input>
          <button onClick = {() => this.enterLocation()}> + </button>
        </div>
        <div id="mapsSidebar">
          {this.state.waypointNames.map((value, index) => {
              return (
                <span key = {[index, "sidebarRow"]} id="mapsSidebarRow">
                  <button key = {index} onClick = {e => this.removeLocation(e, index)}> X </button>
                  <button key = {[index, value]} className="fillWidth" onClick = {e => this.viewLocation(e, index)}> {index + 1}. {value} </button>
                </span>
              );
          })}
          <span id="directionsButton">
          <button className="fillWidth" onClick = {e => this.clearWaypoints(e)}> Clear </button>
          <button className="fillWidth" onClick = {e => this.getDirections(e)}> Get Directions </button>
          </span>
        </div>
        <GoogleMap
          lat = {this.state.currentLat}
          lng = {this.state.currentLng}
          waypointNames = {this.state.waypointNames}
          waypoints = {this.state.waypoints}
          onMapLoad={map => {}}/>
          <div id="mapsDirections" ref="directionsRef"></div>
      </div>
    )
  }
}

class GoogleMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      map: null,
      markers: [],
      polyline: null
    }
    this.onScriptLoad = this.onScriptLoad.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentDidUpdate = this.componentDidUpdate.bind(this);
  }

  onScriptLoad() {
    this.setState(
      {
        map: new window.google.maps.Map(
          this.refs.myMap, {
            zoom: 8,
            minZoom: 2,
            center: {
              lat: this.props.lat,
              lng: this.props.lng,
            },
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: false
          }
        )
      },
      function() {
        this.props.onMapLoad(this.state.map);
      }
    );
  }

  componentDidMount() {
    if(!window.google) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://maps.google.com/maps/api/js?key=AIzaSyAtopCBkuxSYM4M-RBWwNQJma2zR030YQM&libraries=places`;
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(script, x);
      script.addEventListener('load', e => {
        this.onScriptLoad()
      })
    }
    else {
      this.onScriptLoad();
    }
  }

  componentDidUpdate(prevProps) {
    if(this.props !== prevProps) {
      if(this.state.map != null) {
        let clearedMarkers = this.state.markers;
        for(let i = 0; i < clearedMarkers.length; i++) {
          if(clearedMarkers[i] !== null) {
            console.log("update")
            clearedMarkers[i].setMap(null);
            clearedMarkers[i] = null;
          }
        }
        let clearedPolyline = this.state.polyline;
        if(clearedPolyline !== null) {
          clearedPolyline.setMap(null);
        }
        this.setState(
          {
            markers: clearedMarkers,
            polyline: clearedPolyline
          },
          function() {
            let newMarkers = this.state.markers;
            var marker = null;
            for(let i = 0; i < this.props.waypoints.length; i++) {
              if(i < newMarkers.length) {
                  marker = new window.google.maps.Marker({
                    position: this.props.waypoints[i]
                  });
                  marker.setMap(this.state.map);
                  newMarkers[i] = marker;
              }
              else {
                marker = new window.google.maps.Marker({
                  position: this.props.waypoints[i]
                });
                marker.setMap(this.state.map);
                newMarkers.push(marker)
              }
            }
            let newPolyline = null;
            newPolyline = new window.google.maps.Polyline({
              path: this.props.waypoints,
              geodesic: true,
              strokeColor: '#FF0000',
              strokeOpacity: 1.0,
              strokeWeight: 2
            });
            newPolyline.setMap(this.state.map);
            this.setState({
              markers: newMarkers,
              polyline: newPolyline
            })
            this.state.map.setCenter({lat: this.props.lat, lng: this.props.lng});
          }
        )
      }
    }
  }

  render() {
    return (
       <div id="map" ref="myMap"></div>
    )
  }
}

export default Maps;
